import { requestCDN } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const defaultCurrency =
  localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) || process.env.REACT_APP_DEFAULT_CURRENCY;

export const apiGetFacebookLink = (params) => {
  const millis = Date.now();
  return requestCDN("get", `/${defaultCurrency?.toUpperCase()}/facebookservice.json?v=${millis}`);
  // return requestMain("get", `/${defaultCurrency}/facebookservice`, params, false, false);
};
